export default "__VITE_ASSET__Bb5kDls3__"